import { Helpers } from '../../helpers';
import { IForecastHorizontal } from '../../interfaces/iforecast-horizontal';
import { Forecast } from '../forecast';
import { ForecastGlobalRisk } from '../forecast-global-risk';
import { ForecastHorizontalDetail } from '../forecast-horizontal-detail';
import { ForecastParameter } from '../forecast-parameter';
import { ForecastSeasonalRisk } from '../forecast-seasonal-risk';
import { ForecastType } from '../forecast-type';
import { ForecastWellRisk } from '../forecast-well-risk';
import { GasCalculation } from '../gas-calculation';
import { InitialFlowRateQi } from '../initial-flow-rate-qi';
import { OutputRate } from '../output-rate';
import { ProvenDevelopedProducingDataset } from '../proven-developed-producing-dataset';
import { RampType } from '../ramp-type';
import { TypeCurve } from '../type-curve';
import { Unit } from '../unit';

export class ForecastHorizontalBase {
  ForecastHorizontalId: number;
  ForecastId: number;
  ForecastTypeId: number | null;
  OutputRateId: number | null;
  ProvenDevelopedProducingDatasetId: number | null;
  GasCalculationId: number | null;
  InitialFlowRateQiId: number | null;
  InitialFlowRateQiMax: number | null;
  InitialOilRampTypeId: number | null;
  InitialGasRampTypeId: number | null;
  ShutinOilRampTypeId: number | null;
  ShutinGasRampTypeId: number | null;
  IncludeSi: boolean | null;
  SiMergeBufferNumberOfDays: number | null;
  GlobalTerminalDecline: boolean | null;
  TerminalOilDecline: number | null;
  TerminalGasDecline: number | null;
  MinimumPlugAndAbandonRate: number | null;
  UnitId: number | null;
  Name: string | null;
  Description: string | null;
  IsApproved: boolean;
  Created: Date;
  Updated: Date;
  CreatedBy: string | null;
  UpdatedBy: string | null;

  ForecastHorizontalDetails_ForecastHorizontal?: Array<ForecastHorizontalDetail> | null;
  ForecastParameter_ForecastHorizontal?: Array<ForecastParameter> | null;
  ForecastSeasonalRisks_ForecastHorizontal?: Array<ForecastSeasonalRisk> | null;
  TypeCurves_ForecastHorizontal?: Array<TypeCurve> | null;
  Forecast?: Forecast;
  ForecastType?: ForecastType;
  GasCalculation?: GasCalculation;
  InitialFlowRateQi?: InitialFlowRateQi;
  OutputRate?: OutputRate;
  ProvenDevelopedProducingDataset?: ProvenDevelopedProducingDataset;
  Unit?: Unit;
  InitialGasRampType?: RampType;
  InitialOilRampType?: RampType;
  ShutinGasRampType?: RampType;
  ShutinOilRampType?: RampType;
  ForecastGlobalRisk?: ForecastGlobalRisk;
  ForecastWellRisk?: ForecastWellRisk;

  constructor(item?: IForecastHorizontal) {
    if (item) {

      this.ForecastHorizontalId = item.ForecastHorizontalId;
      this.ForecastId = item.ForecastId;
      this.ForecastTypeId = item.ForecastTypeId;
      this.OutputRateId = item.OutputRateId;
      this.ProvenDevelopedProducingDatasetId = item.ProvenDevelopedProducingDatasetId;
      this.GasCalculationId = item.GasCalculationId;
      this.InitialFlowRateQiId = item.InitialFlowRateQiId;
      this.InitialFlowRateQiMax = item.InitialFlowRateQiMax;
      this.InitialOilRampTypeId = item.InitialOilRampTypeId;
      this.InitialGasRampTypeId = item.InitialGasRampTypeId;
      this.ShutinOilRampTypeId = item.ShutinOilRampTypeId;
      this.ShutinGasRampTypeId = item.ShutinGasRampTypeId;
      this.IncludeSi = item.IncludeSi;
      this.SiMergeBufferNumberOfDays = item.SiMergeBufferNumberOfDays;
      this.GlobalTerminalDecline = item.GlobalTerminalDecline;
      this.TerminalOilDecline = item.TerminalOilDecline;
      this.TerminalGasDecline = item.TerminalGasDecline;
      this.MinimumPlugAndAbandonRate = item.MinimumPlugAndAbandonRate;
      this.UnitId = item.UnitId;
      this.Name = item.Name;
      this.Description = item.Description;
      this.IsApproved = item.IsApproved;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.CreatedBy = item.CreatedBy;
      this.UpdatedBy = item.UpdatedBy;

      this.ForecastHorizontalDetails_ForecastHorizontal = Helpers.createClassArray(ForecastHorizontalDetail, item.ForecastHorizontalDetails_ForecastHorizontal);
      this.ForecastParameter_ForecastHorizontal = Helpers.createClassArray(ForecastParameter, item.ForecastParameter_ForecastHorizontal);
      this.ForecastSeasonalRisks_ForecastHorizontal = Helpers.createClassArray(ForecastSeasonalRisk, item.ForecastSeasonalRisks_ForecastHorizontal);
      this.TypeCurves_ForecastHorizontal = Helpers.createClassArray(TypeCurve, item.TypeCurves_ForecastHorizontal);
      this.Forecast = new Forecast(item.Forecast);
      this.ForecastType = new ForecastType(item.ForecastType);
      this.GasCalculation = new GasCalculation(item.GasCalculation);
      this.InitialFlowRateQi = new InitialFlowRateQi(item.InitialFlowRateQi);
      this.OutputRate = new OutputRate(item.OutputRate);
      this.ProvenDevelopedProducingDataset = new ProvenDevelopedProducingDataset(item.ProvenDevelopedProducingDataset);
      this.Unit = new Unit(item.Unit);
      this.InitialGasRampType = new RampType(item.InitialGasRampType);
      this.InitialOilRampType = new RampType(item.InitialOilRampType);
      this.ShutinGasRampType = new RampType(item.ShutinGasRampType);
      this.ShutinOilRampType = new RampType(item.ShutinOilRampType);
      this.ForecastGlobalRisk = new ForecastGlobalRisk(item.ForecastGlobalRisk);
      this.ForecastWellRisk = new ForecastWellRisk(item.ForecastWellRisk);
    }
  }
}